import { Button, Step, StepLabel, Stepper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { limparMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { isUndefinedOrNull, obterObjetoTodosComponentesTocados, rolarVisualizacaoAteElemento, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AgentesNocivos from './AgentesNocivos';
import AmbientesTrabalho from './AmbientesTrabalho';
import ResponsaveisRegistro from './ResponsaveisRegistro';

const BackButton = styled(Button)(({ theme }) => ({
    marginRight: theme.spacing(1),
}));

const StepButtonsBox = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "space-between"
}));

// 16/01/2023
const dataInicioCondicaoValidacaoDataFimCondicao = new Date(2023, 0, 16);

// 22/04/2024
const data_descAgNoc_exclusivamente_vazio_codAgNoc_09_01_001 = new Date(2024, 3, 22);

export function obterDescricaoAgenteNocivo(valorDataInicioCondicao, valorDescricaoAgenteNocivo, naoExisteAgenteNocivo) {
    // Não informar se codAgNoc = [09.01.001] e dtIniCondicao >= [2024-04-22]
    let descricaoAgenteNocivo = valorDescricaoAgenteNocivo;

    if (naoExisteAgenteNocivo) {
        if (new Date(valorDataInicioCondicao) >= data_descAgNoc_exclusivamente_vazio_codAgNoc_09_01_001) {
            descricaoAgenteNocivo = '';
        }
        else {
            descricaoAgenteNocivo = 'Não existe agente nocivo ou de atividades previstas no Anexo IV do Decreto 3.048/1999';
        }
    }

    return descricaoAgenteNocivo;
}

function ExposicaoRiscoRegistro({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const { get, post } = useRequisicaoControlada();

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};
    objetoComponentesTocados['dataInicioCondicao'] = false;
    objetoComponentesTocados['dataFimCondicao'] = false;
    objetoComponentesTocados['descricaoAtividade'] = false;

    const [modelo, setModelo] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});
    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);
    const [visibilidadeStepperButtons, setVisibilidadeStepperButtons] = useState(true);
    const [obrigatoriedadeDataFimCondicao, setObrigatoriedadeDataFimCondicao] = useState(true);

    const processamentoResposta = (conteudoResposta) => {
        setModelo(conteudoResposta);
    };

    function voltarListagem() {
        navigate(`/exposicaoRisco/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    const steps = ['Dados do Local de Trabalho', 'Agentes Nocivos', 'Responsáveis pelo Registro Ambiental'];

    const handleNext = (e) => {
        if (activeStep === 2) {
            handleSubmit(e);
        } else {
            setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
            setNomeFuncaoAcaoFormularioCompletamenteValidado('proximo');
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (modelo != null) {
            setObrigatoriedadeDataFimCondicao(modelo.codCategoria.startsWith('2') && new Date(modelo.dataInicioCondicao.valor) >= dataInicioCondicaoValidacaoDataFimCondicao);
            objetoRegrasValidacao['dataInicioCondicao'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataInicioCondicao.valor), new RegraDiaMesAno(modelo.dataInicioCondicao.valor)], componenteTocadoFormulario['dataInicioCondicao']);
            objetoRegrasValidacao['dataFimCondicao'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataFimCondicao.valor), new RegraDiaMesAno(modelo.dataInicioCondicao.valor)], componenteTocadoFormulario['dataFimCondicao'] && obrigatoriedadeDataFimCondicao);
            objetoRegrasValidacao['descricaoAtividade'] = new RegraObrigatoriedade(modelo.descricaoAtividade.valor, componenteTocadoFormulario['descricaoAtividade']);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [modelo, componenteTocadoFormulario]);

    useEffect(() => {
        async function processamentoInternoAssincrono() {
            const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

            if (regraValidacaoFormulario.todosComponentesTocados) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                    if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                        if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter') {
                            await post("/sst/exposicaoRisco/salvar", modelo, voltarListagem, undefined, { mensagensResistentes: true });
                        } else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'proximo') {
                            setModelo({
                                ...modelo,
                                itemAmbienteTrabalhoAuxiliar: {
                                    localAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: null },
                                    descricaoSetor: { ...modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: null },
                                    tipoInscricaoAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: null },
                                    numeroInscricaoAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: null }
                                },
                                itemResponsavelRegistroAuxiliar: {
                                    cpfResponsavel: { ...modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                                    orgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                                    descricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                                    numeroInscricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                                    ufOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
                                },
                                itemAgenteNocivoAuxiliar: {
                                    codigo: { ...modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                                    ausenciaAgenteNocivo: false,
                                    descricao: { ...modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                                    tipoAvaliacao: { ...modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                                    limiteTolerancia: { ...modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                                    intensidadeConcentracao: { ...modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                                    unidadeMedida: { ...modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                                    tecnicaMedicao: { ...modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                                    numeroProcessoJudicial: { ...modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                                    epc: {
                                        utilizacaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                                        eficienciaProtecaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                                        utilizacaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                                        eficienciaProtecaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                                        listaEpis: [],
                                        epIs: [],
                                        epiComplemento: {
                                            medidaProtecao: false,
                                            condicaoFuncionamento: false,
                                            usoIninterrupto: false,
                                            periodicidadeTroca: false,
                                            prazoValidade: false,
                                            higienizacao: false
                                        }
                                    },
                                }
                            });
                            //console.log(modelo);
                            await post("/sst/exposicaoRisco/validarParcial", modelo, stepValidado);
                        }
                    }
                    else {
                        rolarVisualizacaoAteElementoInvalido();
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        processamentoInternoAssincrono();
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setModelo({
            ...modelo,
            itemAmbienteTrabalhoAuxiliar: {
                localAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: null },
                descricaoSetor: { ...modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: null },
                tipoInscricaoAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: null },
                numeroInscricaoAmbiente: { ...modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: null }
            },
            itemResponsavelRegistroAuxiliar: {
                cpfResponsavel: { ...modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                orgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                descricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                numeroInscricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                ufOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
            },
            itemAgenteNocivoAuxiliar: {
                codigo: { ...modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false
                    }
                },
            }
        });

        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    useEffect(() => {
        rolarVisualizacaoAteElemento('indicador-passos');
    }, [activeStep]);

    function stepValidado(ehValido) {
        if (ehValido) {
            dispatch(limparMensagens());
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    function getStepperButtons(visualizacao) {
        return (
            <Display show={visibilidadeStepperButtons}>
                <StepButtonsBox>
                    <Button color="secondary" size="medium" onClick={() => navigate(-1)}>
                        {!visualizacao ? 'Cancelar' : 'Voltar'}
                    </Button>

                    <div>
                        <BackButton
                            variant="outlined"
                            color="primary"
                            disabled={activeStep < 1}
                            onClick={handleBack}
                        >
                            Anterior
                        </BackButton>

                        <Display show={activeStep !== steps.length - 1}>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleNext}>
                                Próximo
                            </Button>
                        </Display>

                        <Display show={!visualizacao && activeStep === steps.length - 1}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                            >
                                Salvar
                            </Button>
                        </Display>
                    </div>
                </StepButtonsBox>
            </Display>
        );
    }

    async function inicializarModelo(idEvento, idContrato, tsv) {
        // Registro
        if (isUndefinedOrNull(idEvento)) {
            await get(`sst/exposicaoRisco/obterEvento/0/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
        // Visualização ou retificação
        else {
            await get(`sst/exposicaoRisco/obterEvento/${idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
    }

    useEffect(() => {
        inicializarModelo(idEvento, idContrato, tsv);
    }, []);

    const handleChangeDataInicioCondicao = (date) => {
        const limparCampoDataFimCondicao = new Date(date) < dataInicioCondicaoValidacaoDataFimCondicao;

        setModelo({
            ...modelo,
            dataInicioCondicao: { ...modelo.dataInicioCondicao, valor: date },
            dataFimCondicao: { ...modelo.dataFimCondicao, valor: limparCampoDataFimCondicao ? null : modelo.dataFimCondicao.valor },
            listaAgentesNocivos: modelo.listaAgentesNocivos.map((agenteNocivo) => {
                // Relato 4261277 - eSocial - Web SST - Erro no preenchimento do campo {descAgNoc} impedindo o envio do evento S-2240
                const ausenciaAgente = agenteNocivo.codigo == '09.01.001';

                return {
                    ...agenteNocivo,
                    descricao: obterDescricaoAgenteNocivo(date, agenteNocivo.descricao, ausenciaAgente)
                }
            })
        });
    }

    return (
        (modelo !== null && Object.values(regraValidacaoFormulario).length > 0) ?
            <Fragment>
                <TituloPagina>Informações sobre o ambiente de trabalho, atividades desempenhadas e exposição a agentes nocivos</TituloPagina>
                <form id="formExposicaoRisco" onSubmit={(e) => handleSubmit(e)}>
                    <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                        <VepTextField
                            accessor="cpfTrabalhador"
                            label="CPF"
                            model={modelo}
                            xs={12} md={3}
                            readOnly
                            maskPattern={Mascara.CPF}
                        />

                        <CustomTextField
                            xs={12} md={6}
                            label="Nome"
                            value={modelo.nome}
                            readOnly />

                        {(!isUndefinedOrNull(modelo.matricula.valor) && modelo.matricula.valor.length > 0) &&
                            <VepTextField
                                accessor="matricula"
                                label="Matrícula"
                                model={modelo}
                                xs={12} md={3}
                                readOnly
                            />
                        }

                        {((isUndefinedOrNull(modelo.matricula.valor) || modelo.matricula.valor.length == 0) &&
                            !isUndefinedOrNull(modelo.codigoCategoria.valor)) &&
                            <CustomTextField
                                label="Categoria"
                                value={modelo.codigoCategoria.fonteDados[modelo.codigoCategoria.valor]}
                                xs={12} md={12}
                                readOnly
                            />
                        }
                    </Fieldset>

                    <Stepper id="indicador-passos" activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === 0 &&
                        <Fragment>
                            <Fieldset legend="Inicio" spacing={4}>
                                <VepDatePicker
                                    accessor="dataInicioCondicao"
                                    label="Quando o trabalhador iniciou as atividades nas condições de exposição?"
                                    model={modelo}
                                    value={modelo.dataInicioCondicao.valor}
                                    onChange={date => handleChangeDataInicioCondicao(date)}
                                    xs={12} md={7}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormulario['dataInicioCondicao'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataInicioCondicao': true })}
                                />

                                <Display show={obrigatoriedadeDataFimCondicao}>
                                    <VepDatePicker
                                        accessor="dataFimCondicao"
                                        required={obrigatoriedadeDataFimCondicao}
                                        label="Quando o trabalhador terminou as atividades nas condições de exposição?"
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={7}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormulario['dataFimCondicao'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataFimCondicao': true })}
                                    />
                                </Display>
                            </Fieldset>

                            <AmbientesTrabalho modelo={modelo} setModelo={setModelo} somenteVisualizacao={visualizacao}></AmbientesTrabalho>

                            <Fieldset spacing={4}>
                                <VepTextField
                                    accessor="descricaoAtividade"
                                    label="Descrição das atividades físicas ou mentais, realizadas pelo trabalhador"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={4}
                                    required
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormulario['descricaoAtividade'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'descricaoAtividade': true })}
                                />
                            </Fieldset>

                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }

                    {activeStep === 1 &&
                        <Fragment>
                            <AgentesNocivos
                                modelo={modelo}
                                setModelo={setModelo}
                                somenteVisualizacao={visualizacao}
                                setVisibilidadeStepperButtons={setVisibilidadeStepperButtons}
                            ></AgentesNocivos>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }

                    {activeStep === 2 &&
                        <Fragment>
                            <ResponsaveisRegistro modelo={modelo} setModelo={setModelo} somenteVisualizacao={visualizacao}></ResponsaveisRegistro>

                            <Fieldset spacing={4}>
                                <VepTextField
                                    accessor="observacaoComplementar"
                                    label="Há alguma observação complementar referente a registros ambientais?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={4}
                                    readOnly={visualizacao}
                                    required={false}
                                />
                            </Fieldset>

                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                </form>
            </Fragment > :
            <ContentPreview />
    );
}

export default ExposicaoRiscoRegistro;
